import { defineMessages } from 'react-intl';

export const messages: {
	emptyStateDescription: { defaultMessage: string; description: string; id: string };
	emptyStateTitle: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	emptyStateTitle: {
		id: 'hub-connect-extension.hub-connect-empty-state.emptyStateTitle.non-final',
		defaultMessage: 'No connect app available',
		description:
			'Empty state title shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.',
	},
	emptyStateDescription: {
		id: 'hub-connect-extension.hub-connect-empty-state.emptyStateDescription.non-final',
		defaultMessage: 'You haven\u2019t installed a custom app in this section yet.',
		description:
			'Empty state description shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.',
	},
});
